(function() {
  "use strict";
  
  let cleanup = [];

  const setupDragDrop = (event) => {
    console.log("setupDragDrop");
    cleanup.forEach((fn) => {fn()});
    const table = document.querySelector('table.drag-drop');

    if (table == null) {
      return;
    }

    const tbody = table.querySelector('tbody');

    var currRow = null,
        dragElem = null,
        mouseDownX = 0,
        mouseDownY = 0,
        mouseX = 0,
        mouseY = 0,
        mouseDrag = false,
        targetX = 0,
        targetY = 0;

    function init() {
      bindMouse();
    }

    function bindMouse() {
      const mouseDownHandler = (event) => {
        if(event.button != 0) return true;

        let target = getTargetRow(event.target);
        if(target) {
          let coords = getMouseCoords(event);
          mouseDownX = coords.x;
          mouseDownY = coords.y;

          currRow = target;
          addDraggableRow(target);
          currRow.classList.add('is-dragging');

          mouseDrag = true;
        }
      }

      document.addEventListener('mousedown', mouseDownHandler);
      cleanup.push(() => {document.removeEventListener('mousedown', mouseDownHandler)});

      const mouseMoveHandler = (event) => {
        if(!mouseDrag) return;

        let coords = getMouseCoords(event);
        mouseX = coords.x - mouseDownX;
        mouseY = coords.y - mouseDownY;

        moveRow(mouseX, mouseY);
      };

      document.addEventListener('mousemove', mouseMoveHandler)
      cleanup.push(() => {document.removeEventListener('mousemove', mouseMoveHandler)});

      const mouseUpHandler = (event) => {
        if(!mouseDrag) return;

        currRow.classList.remove('is-dragging');
        table.removeChild(dragElem);

        dragElem = null;
        mouseDrag = false;

        let ordering = [];

        document.querySelectorAll("#assets tr").forEach((tr, idx) => {
          ordering.push(tr.dataset.assetId);
          tr.querySelector("td.ordering").innerHTML = idx+1;
        })

        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        fetch(table.dataset.orderingUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({assets: ordering})
        }).then((response) => {
          console.log(response.text());
        }).catch((err) => {
          console.error(err);
        });
      };

      document.addEventListener('mouseup', mouseUpHandler)
      cleanup.push(() => {document.removeEventListener('mouseup', mouseUpHandler)});
    }

    function swapRow(row, index) {
       let currIndex = Array.from(tbody.children).indexOf(currRow),
           row1 = currIndex > index ? currRow : row,
           row2 = currIndex > index ? row : currRow;

       tbody.insertBefore(row1, row2);
    }

    function moveRow(x, y) {
      dragElem.style.transform = "translate3d(" + (targetX + x) + "px, " + (targetY + y) + "px, 0)";

      let dPos = dragElem.getBoundingClientRect(),
          currStartY = dPos.y, currEndY = currStartY + dPos.height,
          rows = getRows();

      for(var i = 0; i < rows.length; i++) {
        let rowElem = rows[i],
            rowSize = rowElem.getBoundingClientRect(),
            rowStartY = rowSize.y, rowEndY = rowStartY + rowSize.height;

        if(currRow !== rowElem && isIntersecting(currStartY, currEndY, rowStartY, rowEndY)) {
          if(Math.abs(currStartY - rowStartY) < rowSize.height / 2)
            swapRow(rowElem, i);
        }
      }
    }

    function addDraggableRow(target) {
        dragElem = target.cloneNode(true);
        dragElem.classList.add('draggable-table__drag');
        dragElem.style.height = getStyle(target, 'height');
        dragElem.style.background = getStyle(target, 'backgroundColor');
        for(var i = 0; i < target.children.length; i++) {
          let oldTD = target.children[i],
              newTD = dragElem.children[i];
          newTD.style.width = getStyle(oldTD, 'width');
          newTD.style.height = getStyle(oldTD, 'height');
          newTD.style.padding = getStyle(oldTD, 'padding');
          newTD.style.margin = getStyle(oldTD, 'margin');
        }

        table.appendChild(dragElem);

        let tPos = target.getBoundingClientRect(),
            dPos = dragElem.getBoundingClientRect();

        targetX = tPos.x - dPos.x;
        targetY = tPos.y - dPos.y;

        moveRow(0,0);
    }

    function getRows() {
      return table.querySelectorAll('tbody tr');
    }

    function getTargetRow(target) {
        let elemName = target.tagName.toLowerCase();

        if(elemName == 'tr') return target;
        if(elemName == 'td') return target.closest('tr');
    }

    function getMouseCoords(event) {
      return {
          x: event.clientX,
          y: event.clientY
      };
    }

    function getStyle(target, styleName) {
      let compStyle = getComputedStyle(target),
          style = compStyle[styleName];

      return style ? style : null;
    }

    function isIntersecting(min0, max0, min1, max1) {
        return Math.max(min0, max0) >= Math.min(min1, max1) &&
               Math.min(min0, max0) <= Math.max(min1, max1);
    }

    init();
  };

  document.addEventListener("turbo:load", setupDragDrop);
})();
